import CommonMultipleTextField from "./CommonMultipleTextField";

export default CommonMultipleTextField;
